module.exports = __webpack_public_path__ + "img/logo_pramita_panjang.5304a156.png";